module.exports = __webpack_public_path__ + "img/joined.996018a1.png";